module.exports = __webpack_public_path__ + "media/images/video/akt-go-logo-53d8dd5157c1cf71fd98e60e9cc9a2d6.png";